import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { resendVerificationEmail } from 'redux/modules/auth';
import { pushModal } from 'redux/modules/modal';
import { showNotification, showSuccess } from 'redux/modules/notification';
import { getEmailSettingsPath } from 'utils/routes';

export default () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onChangeEmail = () => {
    history.push(getEmailSettingsPath());
    dispatch(pushModal({ name: 'UpdateEmail' }));
  };

  const onResendEmail = async (email: string) => {
    try {
      await dispatch(resendVerificationEmail());
      dispatch(
        showSuccess(
          `We’ve emailed ${email}`,
          10,
          undefined,
          'Verification email sent',
        ),
      );
    } catch (error) {
      dispatch(
        showNotification({
          message: 'Please try again or {{link}} so we can help',
          code: 'ER013',
          level: 'error',
          dismissAfterSec: 10,
          type: 'help',
          title: 'Sorry! There was an error sending your email',
          actionLabel: 'contact us',
        }),
      );
    }
  };

  return {
    onResendEmail,
    onChangeEmail,
  };
};
